import { z } from 'zod';
import { dataGridSearchFields } from '@/features/dynamic-table';
import { ContractType } from './-constants';
export const ContractTableFilterSchema = z.object({
  // ページネーション・ソート（DataGrid SDUI 共通。sortColumn は BE スキーマの fieldKey）
  ...dataGridSearchFields,
  // タブフィルタ
  contractType: z.nativeEnum(ContractType).default(ContractType.EMPLOYMENT),
  // フィルタ
  freeText: z.string().optional()
  // TODO: 検索フィルター作ってから利用
  // contractNo: z.string().optional(),
  // contractTitle: z.string().optional(),
  // contractStatus: z.nativeEnum(ContractStatus).optional(),
});